import { createToast } from "mosha-vue-toastify";
import useClipboard from "vue-clipboard3";

export const Toaster = (text, title, type) => {
    createToast(
        {
            description: text,
            title: title,
        },
        {
            type: type,
            position: "bottom-center",
        }
    );
};
export const CopyToClipboard = async (text, toaster) => {
    try {
        const { toClipboard } = useClipboard();

        await toClipboard(text);
        toaster("Copied!", "", "success");
    } catch (e) {
        console.log(e, 'CopyToClipboard Exception');
        toaster("", "Error", "danger");
    }
};
